import { useCallback, useEffect } from 'react';
import {
  browserName,
  browserVersion,
  deviceType,
  engineName,
  engineVersion,
  osName,
  osVersion,
} from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { publicIpv4 } from 'public-ip';

import { api, parseResponse } from '@/library/api/honoClient';

export const sessionCheckAge = 30 * 60 * 1000;

export const SessionUpdate = () => {
  const navigate = useNavigate();

  const updateSessionDetails = useCallback(async () => {
    try {
      let ipAddress: string | undefined = sessionStorage.getItem('publicIpv4') ?? undefined;
      if (!ipAddress) {
        try {
          ipAddress = await publicIpv4();
          if (ipAddress) sessionStorage.setItem('publicIpv4', ipAddress);
        } catch {}
      }

      const payload = {
        deviceType,
        osName,
        osVersion,
        browserName,
        browserVersion,
        engineName,
        engineVersion,
        ipAddress,
      };

      const updated = await parseResponse(api.sessions.update.$post({ json: payload }));

      if (!updated) {
        // Retry once before redirecting - zoom/reload/transient network can cause session read failures
        const retry = await parseResponse(api.sessions.update.$post({ json: payload }));
        if (!retry) {
          navigate('/');
        }
      }
    } catch {
      // transient error — don't kick the user, wait for next tick
    }
  }, [navigate]);

  useEffect(() => {
    void updateSessionDetails();
    const interval = setInterval(updateSessionDetails, sessionCheckAge);
    return () => clearInterval(interval);
  }, [updateSessionDetails]);

  return null;
};
